import { toast } from "react-toastify";

export const ToastMessage = (header, message) => {
  let type = "";
  switch (header) {
    case "SUCCESS":
      type = "success";
      break;

    case "INFO":
      type = "info";
      break;

    case "ERROR":
      type = "error";
      break;

    case "WARN":
      type = "warning";
      break;

    default:
      type = "info";
      break;
  }

  toast[type](message);
};

export const type = {
  SUCCESS: "SUCCESS",
  INFO: "INFO",
  ERROR: "ERROR",
  WARN: "WARN",
};
